var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DateShortcutType } from '../components/Calendar/types';
import { createCalendarItemModel } from './CalendarUtils';
import dayjs from 'dayjs';
import { DefaultCheckDate } from '../types';
/**
 * 将参数值解析为 dayjs 对象，同时支持时间戳和日期字符串（如 '2026-05-10'）
 */
const parseDateParam = (value) => {
    if (!value)
        return null;
    // 纯数字视为时间戳
    if (/^\d+$/.test(String(value))) {
        return dayjs(Number(value));
    }
    // 日期字符串
    const d = dayjs(value);
    return d.isValid() ? d : null;
};
export const getInitCheckDate = (p, isBeforeDawn, current, props) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const checkDates = {
        checkinDay: dayjs(),
        checkoutDay: dayjs(),
        checkinShortcutType: DateShortcutType.unset,
        checkoutShortcutType: DateShortcutType.unset
    };
    switch (props.defaultCheckDate) {
        case DefaultCheckDate.FOLLOW_JUMP_LINK_PARAMS:
        case DefaultCheckDate.FOLLOW_JUMP_LINK_PARAMS_AND_FILL_MIN_DAYS:
            const queryParams = (_a = p === null || p === void 0 ? void 0 : p._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams;
            // 同时支持 checkInDate / checkin_date，优先取 checkInDate
            const rawCheckin = (_b = queryParams === null || queryParams === void 0 ? void 0 : queryParams.checkInDate) !== null && _b !== void 0 ? _b : queryParams === null || queryParams === void 0 ? void 0 : queryParams.checkin_date;
            const rawCheckout = (_c = queryParams === null || queryParams === void 0 ? void 0 : queryParams.checkOutDate) !== null && _c !== void 0 ? _c : queryParams === null || queryParams === void 0 ? void 0 : queryParams.checkout_date;
            let checkinDay = parseDateParam(rawCheckin);
            let checkoutDay = parseDateParam(rawCheckout);
            // 默认最小间夜数，未配置时默认为 1（保证至少今天到明天）
            // eslint-disable-next-line no-case-declarations
            const minDays = props.minDays || 1;
            if (!checkinDay) {
                // 场景：未传入住日期（无论是否传了离店日期，均忽略离店日期）
                checkinDay = dayjs();
                checkoutDay = dayjs().add(minDays, 'day');
            }
            else if (!checkoutDay) {
                // 场景：只传了入住日期，未传离店日期
                checkoutDay = checkinDay.add(minDays, 'day');
            }
            else {
                // 场景：传入完整入离日期
                if (props.defaultCheckDate === DefaultCheckDate.FOLLOW_JUMP_LINK_PARAMS_AND_FILL_MIN_DAYS) {
                    const diffDays = checkoutDay.diff(checkinDay, 'day');
                    if (diffDays <= minDays) {
                        checkoutDay = checkinDay.add(minDays, 'day');
                    }
                }
            }
            checkDates.checkinDay = checkinDay;
            checkDates.checkoutDay = checkoutDay;
            break;
        case DefaultCheckDate.FIXED_CHECK_IN_AND_OUT_DATE:
            checkDates.checkinDay = parseDateParam(props.fixedCheckInDate) || dayjs();
            checkDates.checkoutDay = parseDateParam(props.fixedCheckOutDate) || dayjs();
            break;
        case DefaultCheckDate.TODAY_TOMORROW:
        default:
            // 凌晨入住逻辑
            if (isBeforeDawn) {
                let checkinShortcutType = DateShortcutType.today;
                let checkoutShortcutType = DateShortcutType.tommorrow;
                const currentDayTs = dayjs(`${current === null || current === void 0 ? void 0 : current.year()}-${(current === null || current === void 0 ? void 0 : current.month()) + 1}-${current === null || current === void 0 ? void 0 : current.date()}`).valueOf();
                const checkinTs = checkDates.checkinDay.startOf('day').valueOf();
                const checkoutTs = checkDates.checkoutDay.startOf('day').valueOf();
                if (checkinTs < currentDayTs) {
                    checkinShortcutType = DateShortcutType.todayBeforeDawn;
                }
                else if (checkoutTs === currentDayTs) {
                    checkoutShortcutType = DateShortcutType.today;
                }
                checkDates.checkinShortcutType = checkinShortcutType;
                checkDates.checkoutShortcutType = checkoutShortcutType;
            }
            else {
                checkDates.checkinDay = current.startOf('day');
                checkDates.checkoutDay = current.add(1, 'day').startOf('day');
            }
            break;
    }
    return {
        runtimeInfo: p === null || p === void 0 ? void 0 : p._runtimeInfo,
        checkIn: createCalendarItemModel(checkDates.checkinDay, false, checkDates.checkinShortcutType),
        checkOut: createCalendarItemModel(checkDates.checkoutDay, false, checkDates.checkoutShortcutType)
    };
});
